import React, { FC } from 'react';
import styled from '@emotion/styled';
import Typography from '@unicons-base/Typography/Typography';
import UN_ICONS_TYPOGRAPHY_VARIANT from 'types/unacademyIcons/typography.type';
import Image from '@base/Image';
import Paper from '@unicons-base/Paper/Paper';
import { Fonts, mediaQuery, Spacings } from '@styles/index';

interface CourseMaterialCardProps {
  icon: string;
  title: string;
}

const CardWrapper = styled(Paper)`
  background-color: transparent;
  border: 1px solid var(--color-i-icon-dark-button) !important;
  padding: ${Spacings.SPACING_7B};
  display: flex;
  align-items: center;
  min-width: calc(50% - ${Spacings.SPACING_4B});
  margin: 0 ${Spacings.SPACING_2B} ${Spacings.SPACING_4B};
  ${mediaQuery.uptoMobile} {
    margin: 0 0 ${Spacings.SPACING_4B};
    min-width: 100%;
    padding: 0;
    border: none !important;
  }
`;

const CardIcon = styled.div`
  margin-right: ${Spacings.SPACING_5B};
  ${mediaQuery.uptoMobile} {
    margin-right: ${Spacings.SPACING_4B};
  }
`;

const CardTitle = styled(Typography)`
  font-weight: ${Fonts.BOLD};
  margin-bottom: 0px;
  ${mediaQuery.uptoMobile} {
    font-weight: ${Fonts.SEMIBOLD};
  }
`;

const CourseMaterialCard: FC<CourseMaterialCardProps> = ({ icon, title }) => {
  return (
    <CardWrapper>
      <CardIcon>
        <Image
          src={icon}
          alt={title}
          width={32}
          height={32}
          layout="intrinsic"
        />
      </CardIcon>
      <CardTitle variant={UN_ICONS_TYPOGRAPHY_VARIANT.SUBTITLE2}>
        {title}
      </CardTitle>
    </CardWrapper>
  );
};

CourseMaterialCard.displayName = 'CourseMaterialCard';

export default CourseMaterialCard;
